/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandalonePre from 'base/components/standalone/Pre';

export const DynamicStandalonePre = StandalonePre;
export type DynamicStandalonePreProps = PropsFromComponent<typeof StandalonePre>;

export const DynamicStandalonePreWith = (extras: DynamicStandaloneExtras): typeof StandalonePre => {
    return function DynamicStandalonePre(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Pre');
        return <StandalonePre {...mergeProps({ options: { theme } }, props)} />;
    }
}